import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.readTogetherBonusLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.readTogetherBonusLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.readTogetherBonusLevels.data.readTogetherBonusLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
